import React from "react";
import "./Footer.css";
import LogoName from "../../assets/img/logoname.png";
export default function Footer() {
  return (
    <div className="footer-wrapper">
      <div className="footer-logo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="45"
          viewBox="0 0 142.047 122.188"
        >
          <path
            id="Path_3480"
            data-name="Path 3480"
            d="M57.515-123.3l-4.309-65.245s32.517,4.073,31.054,36.27c0,0,11.5-61.848,38.888-60.016s41.974,82.074-12.828,120.632c-2.322,1.634-8.449,3.391-6.857-3.124.369-1.51,2.235-2.9,4.246-4.892,43.852-43.445,28.912-92.27,13.848-100.393S88-150.84,89.689-140.6s2.137-7.145,9.516-5.708c17.541,3.416,9.261,39.432-11.324,33.622-15.665-4.422-7.245-30.284-12.593-43.681C68.637-173.024,61.579-172.9,61.579-172.9s-1.827,44.679.573,52.844a9.234,9.234,0,0,1,.5,2.626,6.929,6.929,0,0,1,0,1.83c-.787,6.047-8.9,11.971-18.1,13.221s-16.031-2.644-15.244-8.691,8.9-11.972,18.1-13.222A19.62,19.62,0,0,1,57.515-123.3Zm104.563-45.711a8.419,8.419,0,0,1,9.181,7.573,8.418,8.418,0,0,1-7.572,9.181,8.421,8.421,0,0,1-9.182-7.572A8.421,8.421,0,0,1,162.078-169.007Zm-2.6-27.092a8.421,8.421,0,0,1,9.182,7.572,8.42,8.42,0,0,1-7.573,9.182,8.419,8.419,0,0,1-9.181-7.572A8.42,8.42,0,0,1,159.475-196.1Z"
            transform="translate(-29.252 212.327)"
            fill="#fff"
            fillRule="evenodd"
          />
        </svg>

        <img className="footer-logoname" src={LogoName} alt="no" />
      </div>

      <div className="footer-copyright">
        <div style={{ color: "#777E90" }}>
          copyright &#169; UI8 LLC ALL RIGHTS RESERVED{" "}
        </div>
        <div>
          We use cookies for better service{" "}
          <span
            style={{ color: "white", cursor: "pointer", marginLeft: "20px" }}
          >
            Accept
          </span>
        </div>
      </div>
    </div>
  );
}
